export enum MessageType {
  Success,
  Error,
  Warning,
  Alert
}
